import { render, staticRenderFns } from "./DataPesertaSertifikasiNew.vue?vue&type=template&id=21f6ba53&scoped=true&"
import script from "./DataPesertaSertifikasiNew.vue?vue&type=script&lang=js&"
export * from "./DataPesertaSertifikasiNew.vue?vue&type=script&lang=js&"
import style0 from "./DataPesertaSertifikasiNew.vue?vue&type=style&index=0&id=21f6ba53&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f6ba53",
  null
  
)

export default component.exports